
import { has, get } from 'lodash';
import { diff } from 'deep-object-diff';
import { Draft } from 'src/types/common';
import { IOption } from '../component/form';

export function ChangeManager<T extends object>(original: Draft<T>, data: Draft<T>) {
  const changes: Partial<T> = diff(original || {}, data || {});

  /**
   * getWorking retrieves the field from latest data from DB?
   * @param field
   */
  const getWorking = (field: string): any => {
    const active:Draft<Partial<T>> = data || {};
    return get(active, field);
  }

  const getChange = (field: string): any => {
    const change = get(changes, field);
    return isChanged(field) ? change : null;
  };

  /**
   * gettCurrent is actually data from existing original request but not latest data
   * @param field
   */
  const getCurrent = (field: string): any => {
    const existing: Draft<Partial<T>> = original || {};
    return get(existing, field);
  };

  const isSet = (field: string): boolean => {
    return has(original, field);
  };

  const isChanged = (field: string): boolean => {
    const change = get(changes, field);
    if (!isSet(field) && change === undefined)
      return false;
    else
      return (isSet(field) && getWorking(field) === undefined) || has(changes, field);
  };

  const format = (field: string): string => {
    return getCurrent(field) || '(empty)';
  };

  const formatBoolean = (field: string): string => {
    const value = getCurrent(field);
    return value === undefined ? '(empty)' :
      value === true ? 'Yes' : 'No';
  };

  const formatOption = (field: string, map: IOption[]) => {
    const value = getCurrent(field);
    return value === undefined ? '(empty)' :
      map.find((item) => item.key === value)?.label || '(error)';
  };

  const getChangeColor = (field: string): 'cb-removed' | 'cb-modified' | 'cb-added' | undefined => {
    const set = isSet(field);
    const changed = isChanged(field);

    if (!changed) {
      return undefined;
    }

    const change = getChange(field);
    if (change === undefined) {
      return 'cb-removed';
    } else if (!set && change !== undefined) {
      return 'cb-added';
    } else {
      return 'cb-modified';
    }
  };

  return {
    getChangeColor,
    getChange,
    isChanged,
    getCurrent,
    format,
    formatBoolean,
    formatOption
  };
}